import {
    GridToolbarContainerProps,
    Toolbar,
} from "@mui/x-data-grid";
import FilterButton from "@/widget/ProTable/FilterButton";
import Button from "@mui/material/Button";
import {buttonClasses, Grid} from "@mui/material";
import * as React from "react";

import {FilterList, FilterAltOutlined} from "@mui/icons-material";
import {
    TableFilterButtonType,
    useGetTableFilterPannel,
    useSetTableFilterItems,
} from "@/store/dataGrid.c";
import {AddOutlined, DeleteOutlined} from "@mui/icons-material";
import {AuthRouteVO} from "@/service/menu.s";
import {useGetAuthButtons} from "@/store/menu.c";
import MoreButton from "@/widget/ProTable/MoreButton";
import SearchForm from "@/widget/ProTable/SearchForm";
import {UseFormReturn} from "react-hook-form";
import isEmpty from "lodash/isEmpty";
import Stack from "@mui/material/Stack";

export interface ToolbarContainerProps {
    showSearch?: boolean;
    onSearch: (params: any) => void;
    searchForm: UseFormReturn;
    handleToolSelect: (btn: AuthRouteVO) => void;
    tabs?: React.ReactNode;
    code: string
}

const ToolbarContainer = ({
                              showSearch = true,
                              code,
                              onSearch,
                              searchForm,
                              handleToolSelect,
                              tabs
                          }: GridToolbarContainerProps & ToolbarContainerProps) => {
    const tableFilterPannel = useGetTableFilterPannel(code);
    const setTableFilterItems = useSetTableFilterItems(code);
    const moreButtons = useGetAuthButtons(code, [3, 7]);
    const toolButtons = useGetAuthButtons(code, [1, 6]);

    return (
        <Stack bgcolor={'#f5f6fa'} pt={1}>
            {tabs}
            <Grid
                container
                direction={"row"}
                alignContent={"top"}
                alignItems={"top"}
                justifyContent={"space-between"}
            >
                <Grid
                    sx={{
                        // py: 0.6,
                        px: 1,
                        pl: 1.6
                    }}
                    // size={7.5}
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    alignContent={"center"}
                >
                    <SearchForm showSearch={showSearch} searchForm={searchForm} onSearch={onSearch} code={code}/>
                </Grid>
                <Grid size={4.5} pr={0.8} sx={{width: "auto"}}>
                    <Toolbar>
                        <Stack direction={"row"} spacing={1.3} alignContent={"center"}>
                            {!isEmpty(moreButtons) && <MoreButton
                                title={"更多"}
                                handleSelect={handleToolSelect}
                                startIcon={<FilterList/>}
                                items={moreButtons}
                            />}
                            {tableFilterPannel && <FilterButton
                                title={"筛选"}
                                mode={"multiple"}
                                handleSelect={(item: TableFilterButtonType) =>
                                    setTableFilterItems({...item, tag: item.tag == -1 ? 1 : -1})
                                }
                                startIcon={<FilterAltOutlined/>}
                                items={tableFilterPannel}
                            />}
                            {/*<GridToolbarColumnsButton*/}
                            {/*  slotProps={{ button: { startIcon: <ViewWeekOutlinedIcon /> } }}*/}
                            {/*  ref={setColumnAnchorEl}*/}
                            {/*/>*/}
                            {toolButtons?.reverse()?.map((item, index: number) => (
                                <Button
                                    variant="outlined"
                                    key={index}
                                    sx={(theme) => ({
                                        [`& .${buttonClasses.startIcon} > *:nth-of-type(1)`]: {
                                            fontSize: "1.4rem",
                                            width: theme.typography.pxToRem(24),
                                            height: theme.typography.pxToRem(24),
                                        },
                                    })}
                                    onClick={() => handleToolSelect(item)}
                                    startIcon={
                                        item.source == "plus" ? (
                                            <AddOutlined/>
                                        ) : item.source == 'delete' ? (
                                            <DeleteOutlined/>
                                        ) : null
                                    }
                                >
                                    {item.menuName}
                                </Button>
                            ))}
                        </Stack>
                    </Toolbar>
                </Grid>
            </Grid>
        </Stack>

    );
};

export default ToolbarContainer;
